export const CHINA_GROUP = {
  en: "China",
  'zh-Hans': "中国",
  'zh-Hant': "中國",
  options: [
    {
      value: "china",
      en: "Chinese mainland",
      'zh-Hans': "内地",
      'zh-Hant': "內地",
    },
    {
      value: "hong-kong",
      en: "Hong Kong SAR",
      'zh-Hans': "香港",
      'zh-Hant': "香港",
    },
    {
      value: "macao",
      en: "Macao SAR",
      'zh-Hans': "澳门",
      'zh-Hant': "澳門",
    },
    {
      value: "taiwan",
      en: "Taiwan",
      'zh-Hans': "台湾",
      'zh-Hant': "臺灣",
    },
  ],
};

const COUNTRIES = [
  {
    value: "afghanistan",
    en: "Afghanistan",
    'zh-Hans': "阿富汗",
    'zh-Hant': "阿富汗",
  },
  {
    value: "aland-islands",
    en: "Åland Islands",
    'zh-Hans': "奥兰群岛",
    'zh-Hant': "奧蘭群島",
  },
  {
    value: "albania",
    en: "Albania",
    'zh-Hans': "阿尔巴尼亚",
    'zh-Hant': "阿爾巴尼亞",
  },
  {
    value: "algeria",
    en: "Algeria",
    'zh-Hans': "阿尔及利亚",
    'zh-Hant': "阿爾及利亞",
  },
  {
    value: "american-samoa",
    en: "American Samoa",
    'zh-Hans': "美属萨摩亚",
    'zh-Hant': "美屬薩摩亞",
  },
  {
    value: "andorra",
    en: "Andorra",
    'zh-Hans': "安道尔",
    'zh-Hant': "安道爾",
  },
  {
    value: "angola",
    en: "Angola",
    'zh-Hans': "安哥拉",
    'zh-Hant': "安哥拉",
  },
  {
    value: "anguilla",
    en: "Anguilla",
    'zh-Hans': "安圭拉",
    'zh-Hant': "安圭拉",
  },
  {
    value: "antarctica",
    en: "Antarctica",
    'zh-Hans': "南极洲",
    'zh-Hant': "南極洲",
  },
  {
    value: "antigua-and-barbuda",
    en: "Antigua And Barbuda",
    'zh-Hans': "安提瓜和巴布达",
    'zh-Hant': "安提瓜和巴布達",
  },
  {
    value: "argentina",
    en: "Argentina",
    'zh-Hans': "阿根廷",
    'zh-Hant': "阿根廷",
  },
  {
    value: "armenia",
    en: "Armenia",
    'zh-Hans': "亚美尼亚",
    'zh-Hant': "亞美尼亞",
  },
  {
    value: "aruba",
    en: "Aruba",
    'zh-Hans': "阿鲁巴",
    'zh-Hant': "阿魯巴",
  },
  {
    value: "australia",
    en: "Australia",
    'zh-Hans': "澳洲",
    'zh-Hant': "澳洲",
  },
  {
    value: "austria",
    en: "Austria",
    'zh-Hans': "奥地利",
    'zh-Hant': "奧地利",
  },
  {
    value: "azerbaijan",
    en: "Azerbaijan",
    'zh-Hans': "阿塞拜疆",
    'zh-Hant': "阿塞拜疆",
  },
  {
    value: "bahamas",
    en: "Bahamas",
    'zh-Hans': "巴哈马",
    'zh-Hant': "巴哈馬",
  },
  {
    value: "bahrain",
    en: "Bahrain",
    'zh-Hans': "巴林",
    'zh-Hant': "巴林",
  },
  {
    value: "bangladesh",
    en: "Bangladesh",
    'zh-Hans': "孟加拉",
    'zh-Hant': "孟加拉",
  },
  {
    value: "barbados",
    en: "Barbados",
    'zh-Hans': "巴巴多斯",
    'zh-Hant': "巴巴多斯",
  },
  {
    value: "belarus",
    en: "Belarus",
    'zh-Hans': "白俄罗斯",
    'zh-Hant': "白俄羅斯",
  },
  {
    value: "belgium",
    en: "Belgium",
    'zh-Hans': "比利时",
    'zh-Hant': "比利時",
  },
  {
    value: "belize",
    en: "Belize",
    'zh-Hans': "伯利兹",
    'zh-Hant': "伯利茲",
  },
  {
    value: "benin",
    en: "Benin",
    'zh-Hans': "贝宁",
    'zh-Hant': "貝寧",
  },
  {
    value: "bermuda",
    en: "Bermuda",
    'zh-Hans': "百慕大",
    'zh-Hant': "百慕大",
  },
  {
    value: "bhutan",
    en: "Bhutan",
    'zh-Hans': "不丹",
    'zh-Hant': "不丹",
  },
  {
    value: "bolivia",
    en: "Bolivia",
    'zh-Hans': "玻利维亚",
    'zh-Hant': "玻利維亞",
  },
  {
    value: "bosnia-and-herzegovina",
    en: "Bosnia and Herzegovina",
    'zh-Hans': "波斯尼亚与黑塞哥维那",
    'zh-Hant': "波斯尼亞與黑塞哥維那",
  },
  {
    value: "botswana",
    en: "Botswana",
    'zh-Hans': "博茨瓦纳",
    'zh-Hant': "博茨瓦納",
  },
  {
    value: "bouvet-island",
    en: "Bouvet Island",
    'zh-Hans': "布韦岛",
    'zh-Hant': "布韋島",
  },
  {
    value: "brazil",
    en: "Brazil",
    'zh-Hans': "巴西",
    'zh-Hant': "巴西",
  },
  {
    value: "british-virgin-islands",
    en: "British Virgin Islands",
    'zh-Hans': "英属维尔京群岛",
    'zh-Hant': "英屬維爾京群島",
  },
  {
    value: "Brunei",
    en: "Brunei Darussalam",
    'zh-Hans': "汶莱",
    'zh-Hant': "汶萊",
  },
  {
    value: "bulgaria",
    en: "Bulgaria",
    'zh-Hans': "保加利亚",
    'zh-Hant': "保加利亞",
  },
  {
    value: "burkina-faso",
    en: "Burkina Faso",
    'zh-Hans': "布基纳法索",
    'zh-Hant': "布基納法索",
  },
  {
    value: "burundi",
    en: "Burundi",
    'zh-Hans': "布隆迪",
    'zh-Hant': "布隆迪",
  },
  {
    value: "cambodia",
    en: "Cambodia",
    'zh-Hans': "柬埔寨",
    'zh-Hant': "柬埔寨",
  },
  {
    value: "cameroon",
    en: "Cameroon",
    'zh-Hans': "喀麦隆",
    'zh-Hant': "喀麥隆",
  },
  {
    value: "canada",
    en: "Canada",
    'zh-Hans': "加拿大",
    'zh-Hant': "加拿大",
  },
  {
    value: "cape-verde",
    en: "Cape Verde",
    'zh-Hans': "佛得角",
    'zh-Hant': "佛得角",
  },
  {
    value: "caribbean-netherlands",
    en: "Caribbean Netherlands",
    'zh-Hans': "荷兰加勒比区",
    'zh-Hant': "荷蘭加勒比區",
  },
  {
    value: "cayman-islands",
    en: "Cayman Islands",
    'zh-Hans': "开曼群岛",
    'zh-Hant': "開曼群島",
  },
  {
    value: "central-african-republic",
    en: "Central African Republic",
    'zh-Hans': "中非共和国",
    'zh-Hant': "中非共和國",
  },
  {
    value: "chad",
    en: "Chad",
    'zh-Hans': "乍得",
    'zh-Hant': "乍得",
  },
  {
    value: "chagos-archipelago",
    en: "Chagos Archipelago",
    'zh-Hans': "查戈斯群岛",
    'zh-Hant': "查戈斯群島",
  },
  {
    value: "chile",
    en: "Chile",
    'zh-Hans': "智利",
    'zh-Hant': "智利",
  },
  {
    value: "christmas-island",
    en: "Christmas Island",
    'zh-Hans': "圣诞岛",
    'zh-Hant': "聖誕島",
  },
  {
    value: "cocos-keeling-islands",
    en: "Cocos (Keeling) Islands",
    'zh-Hans': "科科斯（基林）群岛",
    'zh-Hant': "科科斯（基林）群島",
  },
  {
    value: "colombia",
    en: "Colombia",
    'zh-Hans': "哥伦比亚",
    'zh-Hant': "哥倫比亞",
  },
  {
    value: "comoros",
    en: "Comoros",
    'zh-Hans': "科摩罗",
    'zh-Hant': "科摩羅",
  },
  {
    value: "cook-islands",
    en: "Cook Islands",
    'zh-Hans': "库克群岛",
    'zh-Hant': "庫克群島",
  },
  {
    value: "costa-rica",
    en: "Costa Rica",
    'zh-Hans': "哥斯达黎加",
    'zh-Hant': "哥斯達黎加",
  },
  {
    value: "cote-divoire",
    en: "Côte d'Ivoire",
    'zh-Hans': "科特迪瓦",
    'zh-Hant': "科特迪瓦",
  },
  {
    value: "croatia",
    en: "Croatia",
    'zh-Hans': "克罗地亚",
    'zh-Hant': "克羅地亞",
  },
  {
    value: "curacao",
    en: "Curaçao",
    'zh-Hans': "库拉索",
    'zh-Hant': "庫拉索",
  },
  {
    value: "cyprus",
    en: "Cyprus",
    'zh-Hans': "塞浦路斯",
    'zh-Hant': "塞浦路斯",
  },
  {
    value: "Czech Republic",
    en: "Czechia",
    'zh-Hans': "捷克",
    'zh-Hant': "捷克",
  },
  {
    value: "democratic-republic-of-the-congo",
    en: "Democratic Republic of the Congo",
    'zh-Hans': "刚果民主共和国",
    'zh-Hant': "剛果民主共和國",
  },
  {
    value: "denmark",
    en: "Denmark",
    'zh-Hans': "丹麦",
    'zh-Hant': "丹麥",
  },
  {
    value: "djibouti",
    en: "Djibouti",
    'zh-Hans': "吉布提",
    'zh-Hant': "吉布提",
  },
  {
    value: "dominica",
    en: "Dominica",
    'zh-Hans': "多米尼克",
    'zh-Hant': "多米尼克",
  },
  {
    value: "dominican-republic",
    en: "Dominican Republic",
    'zh-Hans': "多米尼加共和国",
    'zh-Hant': "多米尼加共和國",
  },
  {
    value: "ecuador",
    en: "Ecuador",
    'zh-Hans': "厄瓜多尔",
    'zh-Hant': "厄瓜多爾",
  },
  {
    value: "egypt",
    en: "Egypt",
    'zh-Hans': "埃及",
    'zh-Hant': "埃及",
  },
  {
    value: "el-salvador",
    en: "El Salvador",
    'zh-Hans': "萨尔瓦多",
    'zh-Hant': "薩爾瓦多",
  },
  {
    value: "equatorial-guinea",
    en: "Equatorial Guinea",
    'zh-Hans': "赤道畿内亚",
    'zh-Hant': "赤道畿內亞",
  },
  {
    value: "eritrea",
    en: "Eritrea",
    'zh-Hans': "厄立特里亚",
    'zh-Hant': "厄立特里亞",
  },
  {
    value: "estonia",
    en: "Estonia",
    'zh-Hans': "爱沙尼亚",
    'zh-Hant': "愛沙尼亞",
  },
  {
    value: "Swaziland",
    en: "Eswatini",
    'zh-Hans': "斯威士兰",
    'zh-Hant': "斯威士蘭",
  },
  {
    value: "ethiopia",
    en: "Ethiopia",
    'zh-Hans': "埃塞俄比亚",
    'zh-Hant': "埃塞俄比亞",
  },
  {
    value: "falkland-islands",
    en: "Falkland Islands",
    'zh-Hans': "福克兰群岛",
    'zh-Hant': "福克蘭群島",
  },
  {
    value: "faroe-islands",
    en: "Faroe Islands",
    'zh-Hans': "法罗群岛",
    'zh-Hant': "法羅群島",
  },
  {
    value: "fiji",
    en: "Fiji",
    'zh-Hans': "斐济",
    'zh-Hant': "斐濟",
  },
  {
    value: "finland",
    en: "Finland",
    'zh-Hans': "芬兰",
    'zh-Hant': "芬蘭",
  },
  {
    value: "france",
    en: "France",
    'zh-Hans': "法国",
    'zh-Hant': "法國",
  },
  {
    value: "french-guiana",
    en: "French Guiana",
    'zh-Hans': "法属圭亚那",
    'zh-Hant': "法屬圭亞那",
  },
  {
    value: "french-polynesia",
    en: "French Polynesia",
    'zh-Hans': "法属波利尼西亚",
    'zh-Hant': "法屬波利尼西亞",
  },
  {
    value: "french-southern-territories",
    en: "French Southern Territories",
    'zh-Hans': "法属南部领地",
    'zh-Hant': "法屬南部領地",
  },
  {
    value: "gabon",
    en: "Gabon",
    'zh-Hans': "加蓬",
    'zh-Hant': "加蓬",
  },
  {
    value: "gambia",
    en: "Gambia",
    'zh-Hans': "冈比亚",
    'zh-Hant': "岡比亞",
  },
  {
    value: "georgia",
    en: "Georgia",
    'zh-Hans': "格鲁吉亚",
    'zh-Hant': "格魯吉亞",
  },
  {
    value: "germany",
    en: "Germany",
    'zh-Hans': "德国",
    'zh-Hant': "德國",
  },
  {
    value: "ghana",
    en: "Ghana",
    'zh-Hans': "加纳",
    'zh-Hant': "加納",
  },
  {
    value: "gibraltar",
    en: "Gibraltar",
    'zh-Hans': "直布罗陀",
    'zh-Hant': "直布羅陀",
  },
  {
    value: "greece",
    en: "Greece",
    'zh-Hans': "希腊",
    'zh-Hant': "希臘",
  },
  {
    value: "greenland",
    en: "Greenland",
    'zh-Hans': "格陵兰",
    'zh-Hant': "格陵蘭",
  },
  {
    value: "grenada",
    en: "Grenada",
    'zh-Hans': "格林纳达",
    'zh-Hant': "格林納達",
  },
  {
    value: "guadeloupe",
    en: "Guadeloupe",
    'zh-Hans': "瓜德罗普",
    'zh-Hant': "瓜德羅普",
  },
  {
    value: "guam",
    en: "Guam",
    'zh-Hans': "关岛",
    'zh-Hant': "關島",
  },
  {
    value: "guatemala",
    en: "Guatemala",
    'zh-Hans': "危地马拉",
    'zh-Hant': "危地馬拉",
  },
  {
    value: "guernsey",
    en: "Guernsey",
    'zh-Hans': "根西",
    'zh-Hant': "根西",
  },
  {
    value: "guinea",
    en: "Guinea",
    'zh-Hans': "畿内亚",
    'zh-Hant': "畿內亞",
  },
  {
    value: "guinea-bissau",
    en: "Guinea-Bissau",
    'zh-Hans': "畿内亚比绍",
    'zh-Hant': "畿內亞比紹",
  },
  {
    value: "guyana",
    en: "Guyana",
    'zh-Hans': "圭亚那",
    'zh-Hant': "圭亞那",
  },
  {
    value: "haiti",
    en: "Haiti",
    'zh-Hans': "海地",
    'zh-Hant': "海地",
  },
  {
    value: "heard-and-mc-donald-islands",
    en: "Heard And Mc Donald Islands",
    'zh-Hans': "赫德岛和麦克唐纳群岛",
    'zh-Hant': "赫德島和麥克唐納群島",
  },
  {
    value: "honduras",
    en: "Honduras",
    'zh-Hans': "洪都拉斯",
    'zh-Hant': "洪都拉斯",
  },
  {
    value: "hungary",
    en: "Hungary",
    'zh-Hans': "匈牙利",
    'zh-Hant': "匈牙利",
  },
  {
    value: "iceland",
    en: "Iceland",
    'zh-Hans': "冰岛",
    'zh-Hant': "冰島",
  },
  {
    value: "india",
    en: "India",
    'zh-Hans': "印度",
    'zh-Hant': "印度",
  },
  {
    value: "indonesia",
    en: "Indonesia",
    'zh-Hans': "印尼",
    'zh-Hant': "印尼",
  },
  {
    value: "iraq",
    en: "Iraq",
    'zh-Hans': "伊拉克",
    'zh-Hant': "伊拉克",
  },
  {
    value: "ireland",
    en: "Ireland",
    'zh-Hans': "爱尔兰",
    'zh-Hant': "愛爾蘭",
  },
  {
    value: "isle-of-man",
    en: "Isle of Man",
    'zh-Hans': "马恩岛",
    'zh-Hant': "馬恩島",
  },
  {
    value: "israel",
    en: "Israel",
    'zh-Hans': "以色列",
    'zh-Hant': "以色列",
  },
  {
    value: "italy",
    en: "Italy",
    'zh-Hans': "意大利",
    'zh-Hant': "意大利",
  },
  {
    value: "jamaica",
    en: "Jamaica",
    'zh-Hans': "牙买加",
    'zh-Hant': "牙買加",
  },
  {
    value: "japan",
    en: "Japan",
    'zh-Hans': "日本",
    'zh-Hant': "日本",
  },
  {
    value: "jersey",
    en: "Jersey",
    'zh-Hans': "泽西",
    'zh-Hant': "澤西",
  },
  {
    value: "jordan",
    en: "Jordan",
    'zh-Hans': "约旦",
    'zh-Hant': "約旦",
  },
  {
    value: "kazakhstan",
    en: "Kazakhstan",
    'zh-Hans': "哈萨克斯坦",
    'zh-Hant': "哈薩克斯坦",
  },
  {
    value: "kenya",
    en: "Kenya",
    'zh-Hans': "肯尼亚",
    'zh-Hant': "肯尼亞",
  },
  {
    value: "kiribati",
    en: "Kiribati",
    'zh-Hans': "基里巴斯",
    'zh-Hant': "基里巴斯",
  },
  {
    value: "kosovo",
    en: "Kosovo",
    'zh-Hans': "科索沃",
    'zh-Hant': "科索沃",
  },
  {
    value: "kuwait",
    en: "Kuwait",
    'zh-Hans': "科威特",
    'zh-Hant': "科威特",
  },
  {
    value: "kyrgyzstan",
    en: "Kyrgyzstan",
    'zh-Hans': "吉尔吉斯斯坦",
    'zh-Hant': "吉爾吉斯斯坦",
  },
  {
    value: "laos",
    en: "Laos",
    'zh-Hans': "老挝",
    'zh-Hant': "老撾",
  },
  {
    value: "latvia",
    en: "Latvia",
    'zh-Hans': "拉脱维亚",
    'zh-Hant': "拉脫維亞",
  },
  {
    value: "lebanon",
    en: "Lebanon",
    'zh-Hans': "黎巴嫩",
    'zh-Hant': "黎巴嫩",
  },
  {
    value: "lesotho",
    en: "Lesotho",
    'zh-Hans': "莱索托",
    'zh-Hant': "萊索托",
  },
  {
    value: "liberia",
    en: "Liberia",
    'zh-Hans': "利比里亚",
    'zh-Hant': "利比里亞",
  },
  {
    value: "libya",
    en: "Libya",
    'zh-Hans': "利比亚",
    'zh-Hant': "利比亞",
  },
  {
    value: "liechtenstein",
    en: "Liechtenstein",
    'zh-Hans': "列支敦士登",
    'zh-Hant': "列支敦士登",
  },
  {
    value: "lithuania",
    en: "Lithuania",
    'zh-Hans': "立陶宛",
    'zh-Hant': "立陶宛",
  },
  {
    value: "luxembourg",
    en: "Luxembourg",
    'zh-Hans': "卢森堡",
    'zh-Hant': "盧森堡",
  },
  {
    value: "madagascar",
    en: "Madagascar",
    'zh-Hans': "马达加斯加",
    'zh-Hant': "馬達加斯加",
  },
  {
    value: "malawi",
    en: "Malawi",
    'zh-Hans': "马拉维",
    'zh-Hant': "馬拉維",
  },
  {
    value: "malaysia",
    en: "Malaysia",
    'zh-Hans': "马来西亚",
    'zh-Hant': "馬來西亞",
  },
  {
    value: "maldives",
    en: "Maldives",
    'zh-Hans': "马尔代夫",
    'zh-Hant': "馬爾代夫",
  },
  {
    value: "mali",
    en: "Mali",
    'zh-Hans': "马里",
    'zh-Hant': "馬里",
  },
  {
    value: "malta",
    en: "Malta",
    'zh-Hans': "马耳他",
    'zh-Hant': "馬耳他",
  },
  {
    value: "marshall-islands",
    en: "Marshall Islands",
    'zh-Hans': "马绍尔群岛",
    'zh-Hant': "馬紹爾群島",
  },
  {
    value: "martinique",
    en: "Martinique",
    'zh-Hans': "马提尼克",
    'zh-Hant': "馬提尼克",
  },
  {
    value: "mauritania",
    en: "Mauritania",
    'zh-Hans': "毛里塔尼亚",
    'zh-Hant': "毛里塔尼亞",
  },
  {
    value: "mauritius",
    en: "Mauritius",
    'zh-Hans': "毛里求斯",
    'zh-Hant': "毛里求斯",
  },
  {
    value: "mayotte",
    en: "Mayotte",
    'zh-Hans': "马纽特岛",
    'zh-Hant': "馬紐特島",
  },
  {
    value: "mexico",
    en: "Mexico",
    'zh-Hans': "墨西哥",
    'zh-Hant': "墨西哥",
  },
  {
    value: "micronesia",
    en: "Micronesia",
    'zh-Hans': "密克罗尼西亚",
    'zh-Hant': "密克羅尼西亞",
  },
  {
    value: "moldova",
    en: "Moldova",
    'zh-Hans': "摩尔多瓦",
    'zh-Hant': "摩爾多瓦",
  },
  {
    value: "monaco",
    en: "Monaco",
    'zh-Hans': "摩纳哥",
    'zh-Hant': "摩納哥",
  },
  {
    value: "mongolia",
    en: "Mongolia",
    'zh-Hans': "蒙古",
    'zh-Hant': "蒙古",
  },
  {
    value: "montenegro",
    en: "Montenegro",
    'zh-Hans': "蒙特内哥罗",
    'zh-Hant': "蒙特內哥羅",
  },
  {
    value: "montserrat",
    en: "Montserrat",
    'zh-Hans': "蒙特塞拉特",
    'zh-Hant': "蒙特塞拉特",
  },
  {
    value: "morocco",
    en: "Morocco",
    'zh-Hans': "摩洛哥",
    'zh-Hant': "摩洛哥",
  },
  {
    value: "mozambique",
    en: "Mozambique",
    'zh-Hans': "莫桑比克",
    'zh-Hant': "莫桑比克",
  },
  {
    value: "Myanmar (Burma)",
    en: "Myanmar",
    'zh-Hans': "缅甸",
    'zh-Hant': "緬甸",
  },
  {
    value: "namibia",
    en: "Namibia",
    'zh-Hans': "纳米比亚",
    'zh-Hant': "納米比亞",
  },
  {
    value: "nauru",
    en: "Nauru",
    'zh-Hans': "瑙鲁",
    'zh-Hant': "瑙魯",
  },
  {
    value: "nepal",
    en: "Nepal",
    'zh-Hans': "尼泊尔",
    'zh-Hant': "尼泊爾",
  },
  {
    value: "netherlands",
    en: "Netherlands",
    'zh-Hans': "荷兰",
    'zh-Hant': "荷蘭",
  },
  {
    value: "new-caledonia",
    en: "New Caledonia",
    'zh-Hans': "新喀里多尼亚",
    'zh-Hant': "新喀里多尼亞",
  },
  {
    value: "new-zealand",
    en: "New Zealand",
    'zh-Hans': "新西兰",
    'zh-Hant': "新西蘭",
  },
  {
    value: "nicaragua",
    en: "Nicaragua",
    'zh-Hans': "尼加拉瓜",
    'zh-Hant': "尼加拉瓜",
  },
  {
    value: "niger",
    en: "Niger",
    'zh-Hans': "尼日尔",
    'zh-Hant': "尼日爾",
  },
  {
    value: "nigeria",
    en: "Nigeria",
    'zh-Hans': "尼日利亚",
    'zh-Hant': "尼日利亞",
  },
  {
    value: "niue",
    en: "Niue",
    'zh-Hans': "纽埃",
    'zh-Hant': "紐埃",
  },
  {
    value: "norfolk-island",
    en: "Norfolk Island",
    'zh-Hans': "诺福克岛",
    'zh-Hant': "諾福克島",
  },
  {
    value: "northern-mariana-islands",
    en: "Northern Mariana Islands",
    'zh-Hans': "北马里亚纳群岛",
    'zh-Hant': "北馬里亞納群島",
  },
  {
    value: "Macedonia",
    en: "North Macedonia",
    'zh-Hans': "马其顿",
    'zh-Hant': "馬其頓",
  },
  {
    value: "norway",
    en: "Norway",
    'zh-Hans': "挪威",
    'zh-Hant': "挪威",
  },
  {
    value: "oman",
    en: "Oman",
    'zh-Hans': "阿曼",
    'zh-Hant': "阿曼",
  },
  {
    value: "pakistan",
    en: "Pakistan",
    'zh-Hans': "巴基斯坦",
    'zh-Hant': "巴基斯坦",
  },
  {
    value: "palau",
    en: "Palau",
    'zh-Hans': "帕劳",
    'zh-Hant': "帕勞",
  },
  {
    value: "palestinian-territories",
    en: "Palestinian Territories",
    'zh-Hans': "巴勒斯坦领土",
    'zh-Hant': "巴勒斯坦領土",
  },
  {
    value: "panama",
    en: "Panama",
    'zh-Hans': "巴拿马",
    'zh-Hant': "巴拿馬",
  },
  {
    value: "papua-new-guinea",
    en: "Papua New Guinea",
    'zh-Hans': "巴布亚新几内亚",
    'zh-Hant': "巴布亞新幾內亞",
  },
  {
    value: "paraguay",
    en: "Paraguay",
    'zh-Hans': "巴拉圭",
    'zh-Hant': "巴拉圭",
  },
  {
    value: "peru",
    en: "Peru",
    'zh-Hans': "秘鲁",
    'zh-Hant': "秘魯",
  },
  {
    value: "philippines",
    en: "Philippines",
    'zh-Hans': "菲律宾",
    'zh-Hant': "菲律賓",
  },
  {
    value: "pitcairn",
    en: "Pitcairn",
    'zh-Hans': "皮特凯恩",
    'zh-Hant': "皮特凱恩",
  },
  {
    value: "poland",
    en: "Poland",
    'zh-Hans': "波兰",
    'zh-Hant': "波蘭",
  },
  {
    value: "portugal",
    en: "Portugal",
    'zh-Hans': "葡萄牙",
    'zh-Hant': "葡萄牙",
  },
  {
    value: "puerto-rico",
    en: "Puerto Rico",
    'zh-Hans': "波多黎各",
    'zh-Hant': "波多黎各",
  },
  {
    value: "qatar",
    en: "Qatar",
    'zh-Hans': "卡塔尔",
    'zh-Hant': "卡塔爾",
  },
  {
    value: "republic-of-the-congo",
    en: "Republic of the Congo",
    'zh-Hans': "刚果共和国",
    'zh-Hant': "剛果共和國",
  },
  {
    value: "reunion",
    en: "Réunion",
    'zh-Hans': "留尼旺",
    'zh-Hant': "留尼旺",
  },
  {
    value: "romania",
    en: "Romania",
    'zh-Hans': "罗马尼亚",
    'zh-Hant': "羅馬尼亞",
  },
  {
    value: "russia",
    en: "Russia",
    'zh-Hans': "俄罗斯",
    'zh-Hant': "俄羅斯",
  },
  {
    value: "rwanda",
    en: "Rwanda",
    'zh-Hans': "卢旺达",
    'zh-Hant': "盧旺達",
  },
  {
    value: "saint-barthelemy",
    en: "Saint Barthélemy",
    'zh-Hans': "圣巴泰勒米",
    'zh-Hant': "聖巴泰勒米",
  },
  {
    value: "Saint Helena, Ascension and Tristan da Cunha (UK)",
    en: "Saint Helena",
    'zh-Hans': "圣赫勒拿、亚森欣和崔斯坦达库尼亚",
    'zh-Hant': "聖赫勒拿、亞森欣和崔斯坦達庫尼亞",
  },
  {
    value: "saint-kitts-and-nevis",
    en: "Saint Kitts And Nevis",
    'zh-Hans': "圣基茨和尼维斯",
    'zh-Hant': "聖基茨和尼維斯",
  },
  {
    value: "saint-lucia",
    en: "Saint Lucia",
    'zh-Hans': "圣卢西亚",
    'zh-Hant': "聖盧西亞",
  },
  {
    value: "saint-martin",
    en: "Saint Martin",
    'zh-Hans': "圣马丁",
    'zh-Hant': "聖馬丁",
  },
  {
    value: "saint-vincent-and-the-grenadines",
    en: "Saint Vincent and the Grenadines",
    'zh-Hans': "圣文森特和格林纳丁斯",
    'zh-Hant': "聖文森特和格林納丁斯",
  },
  {
    value: "samoa",
    en: "Samoa",
    'zh-Hans': "萨摩亚",
    'zh-Hant': "薩摩亞",
  },
  {
    value: "san-marino",
    en: "San Marino",
    'zh-Hans': "圣马力诺",
    'zh-Hant': "聖馬力諾",
  },
  {
    value: "São Tomé and Príncipe",
    en: "Sao Tome And Principe",
    'zh-Hans': "圣多美普林西比",
    'zh-Hant': "聖多美普林西比",
  },
  {
    value: "saudi-arabia",
    en: "Saudi Arabia",
    'zh-Hans': "沙特阿拉伯",
    'zh-Hant': "沙特阿拉伯",
  },
  {
    value: "senegal",
    en: "Senegal",
    'zh-Hans': "塞内加尔",
    'zh-Hant': "塞內加爾",
  },
  {
    value: "serbia",
    en: "Serbia",
    'zh-Hans': "塞尔维亚",
    'zh-Hant': "塞爾維亞",
  },
  {
    value: "seychelles",
    en: "Seychelles",
    'zh-Hans': "塞舌尔",
    'zh-Hant': "塞舌爾",
  },
  {
    value: "sierra-leone",
    en: "Sierra Leone",
    'zh-Hans': "塞拉利昂",
    'zh-Hant': "塞拉利昂",
  },
  {
    value: "singapore",
    en: "Singapore",
    'zh-Hans': "新加坡",
    'zh-Hant': "新加坡",
  },
  {
    value: "sint-maarten",
    en: "Sint Maarten",
    'zh-Hans': "圣马丁（荷属）",
    'zh-Hant': "聖馬丁（荷屬）",
  },
  {
    value: "slovakia",
    en: "Slovakia",
    'zh-Hans': "斯洛伐克",
    'zh-Hant': "斯洛伐克",
  },
  {
    value: "slovenia",
    en: "Slovenia",
    'zh-Hans': "斯洛文尼亚",
    'zh-Hant': "斯洛文尼亞",
  },
  {
    value: "solomon-islands",
    en: "Solomon Islands",
    'zh-Hans': "所罗门群岛",
    'zh-Hant': "所羅門群島",
  },
  {
    value: "somalia",
    en: "Somalia",
    'zh-Hans': "索马里",
    'zh-Hant': "索馬里",
  },
  {
    value: "south-africa",
    en: "South Africa",
    'zh-Hans': "南非",
    'zh-Hant': "南非",
  },
  {
    value: "south-georgia-and-south-sandwich-islands",
    en: "South Georgia and South Sandwich Islands",
    'zh-Hans': "南乔治亚和南桑威奇群岛",
    'zh-Hant': "南喬治亞和南桑威奇群島",
  },
  {
    value: "Korea, South",
    en: "South Korea",
    'zh-Hans': "南韩",
    'zh-Hant': "南韓",
  },
  {
    value: "south-sudan",
    en: "South Sudan",
    'zh-Hans': "南苏丹",
    'zh-Hant': "南蘇丹",
  },
  {
    value: "spain",
    en: "Spain",
    'zh-Hans': "西班牙",
    'zh-Hant': "西班牙",
  },
  {
    value: "sri-lanka",
    en: "Sri Lanka",
    'zh-Hans': "斯里兰卡",
    'zh-Hant': "斯里蘭卡",
  },
  {
    value: "st-pierre-and-miquelon",
    en: "St. Pierre And Miquelon",
    'zh-Hans': "圣皮埃尔和密克隆",
    'zh-Hant': "聖皮埃爾和密克隆",
  },
  {
    value: "sudan",
    en: "Sudan",
    'zh-Hans': "苏丹",
    'zh-Hant': "蘇丹",
  },
  {
    value: "suriname",
    en: "Suriname",
    'zh-Hans': "苏里南",
    'zh-Hant': "蘇里南",
  },
  {
    value: "svalbard-and-jan-mayen-islands",
    en: "Svalbard And Jan Mayen Islands",
    'zh-Hans': "斯瓦尔巴和扬马延",
    'zh-Hant': "斯瓦爾巴和揚馬延",
  },
  {
    value: "sweden",
    en: "Sweden",
    'zh-Hans': "瑞典",
    'zh-Hant': "瑞典",
  },
  {
    value: "switzerland",
    en: "Switzerland",
    'zh-Hans': "瑞士",
    'zh-Hant': "瑞士",
  },
  {
    value: "tajikistan",
    en: "Tajikistan",
    'zh-Hans': "塔吉克斯坦",
    'zh-Hant': "塔吉克斯坦",
  },
  {
    value: "tanzania",
    en: "Tanzania",
    'zh-Hans': "坦桑尼亚",
    'zh-Hant': "坦桑尼亞",
  },
  {
    value: "thailand",
    en: "Thailand",
    'zh-Hans': "泰国",
    'zh-Hant': "泰國",
  },
  {
    value: "East Timor (Timor Timur)",
    en: "Timor-Leste",
    'zh-Hans': "东帝汶",
    'zh-Hant': "東帝汶",
  },
  {
    value: "togo",
    en: "Togo",
    'zh-Hans': "多哥",
    'zh-Hant': "多哥",
  },
  {
    value: "tokelau",
    en: "Tokelau",
    'zh-Hans': "托克劳",
    'zh-Hant': "托克勞",
  },
  {
    value: "tonga",
    en: "Tonga",
    'zh-Hans': "汤加",
    'zh-Hant': "湯加",
  },
  {
    value: "trinidad-and-tobago",
    en: "Trinidad and Tobago",
    'zh-Hans': "特立尼达和多巴哥",
    'zh-Hant': "特立尼達和多巴哥",
  },
  {
    value: "tunisia",
    en: "Tunisia",
    'zh-Hans': "突尼斯",
    'zh-Hant': "突尼斯",
  },
  {
    value: "turkey",
    en: "Turkey",
    'zh-Hans': "土耳其",
    'zh-Hant': "土耳其",
  },
  {
    value: "turkmenistan",
    en: "Turkmenistan",
    'zh-Hans': "土库曼斯坦",
    'zh-Hant': "土庫曼斯坦",
  },
  {
    value: "turks-and-caicos-islands",
    en: "Turks and Caicos Islands",
    'zh-Hans': "特克斯和凯科斯群岛",
    'zh-Hant': "特克斯和凱科斯群島",
  },
  {
    value: "tuvalu",
    en: "Tuvalu",
    'zh-Hans': "图瓦卢",
    'zh-Hant': "圖瓦盧",
  },
  {
    value: "uganda",
    en: "Uganda",
    'zh-Hans': "乌干达",
    'zh-Hant': "烏干達",
  },
  {
    value: "ukraine",
    en: "Ukraine",
    'zh-Hans': "乌克兰",
    'zh-Hant': "烏克蘭",
  },
  {
    value: "united-arab-emirates",
    en: "United Arab Emirates",
    'zh-Hans': "阿拉伯联合酋长国",
    'zh-Hant': "阿拉伯聯合酋長國",
  },
  {
    value: "united-kingdom",
    en: "United Kingdom",
    'zh-Hans': "英国",
    'zh-Hant': "英國",
  },
  {
    value: "united-states",
    en: "United States",
    'zh-Hans': "美国",
    'zh-Hant': "美國",
  },
  {
    value: "united-states-minor-outlying-islands",
    en: "United States Minor Outlying Islands",
    'zh-Hans': "美国本土外小岛屿",
    'zh-Hant': "美國本土外小島嶼",
  },
  {
    value: "uruguay",
    en: "Uruguay",
    'zh-Hans': "乌拉圭",
    'zh-Hant': "烏拉圭",
  },
  {
    value: "uzbekistan",
    en: "Uzbekistan",
    'zh-Hans': "乌兹别克斯坦",
    'zh-Hant': "烏茲別克斯坦",
  },
  {
    value: "vanuatu",
    en: "Vanuatu",
    'zh-Hans': "瓦努阿图",
    'zh-Hant': "瓦努阿圖",
  },
  {
    value: "vatican",
    en: "Vatican",
    'zh-Hans': "梵蒂冈",
    'zh-Hant': "梵蒂岡",
  },
  {
    value: "venezuela",
    en: "Venezuela",
    'zh-Hans': "委内瑞拉",
    'zh-Hant': "委內瑞拉",
  },
  {
    value: "vietnam",
    en: "Vietnam",
    'zh-Hans': "越南",
    'zh-Hant': "越南",
  },
  {
    value: "virgin-islands-us",
    en: "Virgin Islands (U.S.)",
    'zh-Hans': "美属维尔京群岛",
    'zh-Hant': "美屬維爾京群島",
  },
  {
    value: "wallis-and-futuna-islands",
    en: "Wallis And Futuna Islands",
    'zh-Hans': "瓦利斯和富图纳",
    'zh-Hant': "瓦利斯和富圖納",
  },
  {
    value: "western-sahara",
    en: "Western Sahara",
    'zh-Hans': "西撒哈拉",
    'zh-Hant': "西撒哈拉",
  },
  {
    value: "yemen",
    en: "Yemen",
    'zh-Hans': "也门",
    'zh-Hant': "也門",
  },
  {
    value: "zambia",
    en: "Zambia",
    'zh-Hans': "赞比亚",
    'zh-Hant': "贊比亞",
  },
  {
    value: "zimbabwe",
    en: "Zimbabwe",
    'zh-Hans': "津巴布韦",
    'zh-Hant': "津巴布韋",
  },
  {
    value: "other",
    en: "Other",
    'zh-Hans': "其他",
    'zh-Hant': "其他",
  }
];

export default COUNTRIES;
